export default __webpack_public_path__ + "static/media/LogoBlack.b08cf1c6.svg";